/**
 * Created by jiangtao=
 * 用于自定方法
 * this.events.$event.on(this.events.page.save, fn)
 * this.events.$event.emit(this.events.page.save)
 * 每个事件注册一次，执行多次，主要解决跨组件 业务代码调用的问题
 */
import Events from '../../libs/Events'
const state = {
  $event: new Events,
  app: {},
  page: {
    save: 'page.save',
    preview: 'page.preview',
    scroll: 'page.scroll',
    menu: 'page.menu.close'
  },
  flow: {},
  spider: {
    get: 'spider.get',
    reset: 'spider.reset',
    url: 'spider.url'
  },
  control: {
    tabs: 'control.tabs',
    transfer: 'control.transfer',
    html: 'control.html'
  }

};

const mutations = {
};

export default {
  state
}



// WEBPACK FOOTER //
// ./src/vuex/stores/events.js